module.exports = __webpack_public_path__ + "static/media/Xr41-logo.de98df66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Xr41/Xr41-logo.svg
// module id = 703
// module chunks = 0